module.exports = __webpack_public_path__ + "static/img/banner1.1a51f21.png";


//////////////////
// WEBPACK FOOTER
// ./static/images2/banner1.png
// module id = J/TA
// module chunks = 2